import React, { useRef } from "react";
import "./placeDetails.css";

import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import person from "../../images/icons/person-standing.png";
import InputBox from "../commonComponents/inputComponents/InputBox";

import { Link } from "react-router-dom";
import { toast } from "react-toastify";

import { useNavigate } from "react-router-dom";

import { useShipping } from "../../contexts/ShippingContext";

export default function InPersonDetail() {
  const navigate = useNavigate();
  const personRef = useRef();

  const { addDeliveryInfo } = useShipping();

  function handleSubmit(e) {
    e.preventDefault();

    const personInfo = personRef.current.value;

    if (!personInfo) {
      toast.error("لطفا اطلاعات صحیح را وارد کنید");
      return;
    }

    addDeliveryInfo("FOOT", {
      person_look_like: personInfo,
    });

    navigate("/shipping/location");
  }
  return (
    <div className="detail-main-container">
      <div className="place-detail-text">
        <h2 className="middle-box-header">من اینجا..</h2>
        <div className="place-item detail-item">
          <span className="place-item-icon">
            <img src={person} alt="" className="detail-person" />
          </span>
          پیاده هستم
        </div>

        <Link to="/shipping/type" className="detail-return-link">
          <span className="return-text detail-return-text">
            بازگشت
            <FontAwesomeIcon icon={faChevronLeft} className="return-icon" />
          </span>
        </Link>
      </div>
      <div className="detail-information">
        <form action="" className="detail-info-form" onSubmit={handleSubmit}>
          <InputBox
            gap="20px"
            label="مشخصات ظاهری من"
            name="person-info"
            ref={personRef}
          />
          <button className="red-submit-btn detail-submit-btn">ثبت</button>
        </form>
      </div>
    </div>
  );
}
